import { useState, useEffect } from "react";
import { loginUser } from "../services/api";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [bg, setBg] = useState("");

  const nav = useNavigate();

  // Soft Dynamic Background
  useEffect(() => {
    const hour = new Date().getHours();

    if (hour >= 6 && hour < 12) {
      setBg("linear-gradient(135deg, #eef2ff, #e0e7ff)");
    } else if (hour >= 12 && hour < 17) {
      setBg("linear-gradient(135deg, #f8fafc, #e2e8f0)");
    } else if (hour >= 17 && hour < 20) {
      setBg("linear-gradient(135deg, #ede9fe, #ddd6fe)");
    } else {
      setBg("linear-gradient(135deg, #dbeafe, #e0f2fe)");
    }
  }, []);

  // Login
  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      return toast.error("Fill all fields");
    }

    setLoading(true);

    try {
      await loginUser({ email, password });

      toast.success("Login successful");

      setTimeout(() => {
        nav("/dashboard");
      }, 800);
    } catch (err) {
      toast.error(err.response?.data?.msg || "Login failed");
    }

    setLoading(false);
  };

  return (
    <>
      <Toaster position="top-right" />

      <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          font-family: "Inter", sans-serif;
        }

        .container {
          min-height: 100vh;

          display: flex;
          justify-content: center;
          align-items: center;

          padding: 24px;

          position: relative;
          overflow: hidden;

          transition: 0.5s ease;
        }

        /* Background Glow */

        .container::before {
          content: "";

          position: absolute;

          width: 450px;
          height: 450px;

          background: rgba(99, 102, 241, 0.12);

          filter: blur(120px);

          top: -120px;
          right: -120px;

          border-radius: 50%;
        }

        .container::after {
          content: "";

          position: absolute;

          width: 420px;
          height: 420px;

          background: rgba(168, 85, 247, 0.10);

          filter: blur(120px);

          bottom: -140px;
          left: -140px;

          border-radius: 50%;
        }

        /* Card */

        .card {
          position: relative;
          z-index: 2;

          width: 100%;
          max-width: 430px;

          padding: 42px 34px;

          border-radius: 30px;

          background: rgba(255, 255, 255, 0.72);

          backdrop-filter: blur(18px);

          border: 1px solid rgba(255, 255, 255, 0.5);

          box-shadow:
            0 20px 60px rgba(15, 23, 42, 0.10),
            inset 0 1px 1px rgba(255, 255, 255, 0.35);

          animation: fadeUp 0.7s ease;
        }

        /* Logo */

        .logo {
          width: 74px;
          height: 74px;

          margin: 0 auto 20px;

          border-radius: 22px;

          background: linear-gradient(135deg, #6366f1, #8b5cf6);

          display: flex;
          align-items: center;
          justify-content: center;

          font-size: 28px;
          font-weight: 800;

          color: white;

          box-shadow: 0 12px 28px rgba(99, 102, 241, 0.25);
        }

        /* Heading */

        h2 {
          text-align: center;

          font-size: 2rem;
          font-weight: 800;

          color: #0f172a;

          margin-bottom: 8px;
        }

        .sub {
          text-align: center;

          color: #475569;

          font-size: 0.95rem;

          margin-bottom: 30px;

          line-height: 1.6;
        }

        /* Inputs */

        .input-group {
          position: relative;
          margin-bottom: 18px;
        }

        input {
          width: 100%;

          padding: 15px 16px;

          border-radius: 14px;

          border: 1px solid #dbe2ea;

          outline: none;

          background: rgba(255, 255, 255, 0.85);

          color: #0f172a;

          font-size: 0.95rem;

          transition: 0.3s ease;
        }

        input::placeholder {
          color: #94a3b8;
        }

        input:focus {
          border-color: #6366f1;

          box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.12);
        }

        /* Toggle */

        .toggle {
          position: absolute;

          right: 16px;
          top: 50%;

          transform: translateY(-50%);

          cursor: pointer;

          font-size: 0.82rem;
          font-weight: 600;

          color: #6366f1;

          user-select: none;
        }

        /* Button */

        button {
          width: 100%;

          padding: 15px;

          border: none;
          border-radius: 14px;

          background: linear-gradient(135deg, #6366f1, #8b5cf6);

          color: white;

          font-size: 1rem;
          font-weight: 700;

          cursor: pointer;

          transition: 0.3s ease;

          margin-top: 6px;

          box-shadow: 0 10px 25px rgba(99, 102, 241, 0.25);
        }

        button:hover {
          transform: translateY(-2px);

          box-shadow: 0 16px 30px rgba(99, 102, 241, 0.35);
        }

        button:active {
          transform: scale(0.98);
        }

        button:disabled {
          background: #94a3b8;
          cursor: not-allowed;
          box-shadow: none;
        }

        /* Forgot */

        .forgot {
          margin-top: 18px;

          text-align: center;

          color: #64748b;

          font-size: 0.92rem;

          cursor: pointer;

          transition: 0.3s ease;
        }

        .forgot:hover {
          color: #6366f1;
        }

        /* Divider */

        .divider {
          display: flex;
          align-items: center;

          gap: 12px;

          margin: 26px 0;

          color: #94a3b8;

          font-size: 0.82rem;
        }

        .divider::before,
        .divider::after {
          content: "";

          flex: 1;

          height: 1px;

          background: #e2e8f0;
        }

        /* Footer */

        .footer {
          text-align: center;

          color: #94a3b8;

          font-size: 0.82rem;
        }

        /* Animation */

        @keyframes fadeUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }

          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* Mobile */

        @media (max-width: 480px) {
          .card {
            padding: 32px 22px;
            border-radius: 24px;
          }

          h2 {
            font-size: 1.7rem;
          }

          .logo {
            width: 64px;
            height: 64px;
            font-size: 24px;
          }
        }
      `}</style>

      <div className="container" style={{ background: bg }}>
        <form className="card" onSubmit={handleLogin}>
          <div className="logo">A</div>

          <h2>Admin Login</h2>

          <p className="sub">
            Access your car management dashboard securely
          </p>

          <div className="input-group">
            <input
              type="email"
              placeholder="Email Address"
              autoComplete="email"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="input-group">
            <input
              type={showPass ? "text" : "password"}
              placeholder="Password"
              autoComplete="current-password"
              onChange={(e) => setPassword(e.target.value)}
            />

            <span
              className="toggle"
              onClick={() => setShowPass(!showPass)}
            >
              {showPass ? "Hide" : "Show"}
            </span>
          </div>

          <button type="submit" disabled={loading}>
            {loading ? "Processing..." : "Login"}
          </button>

          <p className="forgot" onClick={() => nav("/reset")}>
            Forgot Password?
          </p>

          <div className="divider">Secure Access</div>

          <p className="footer">
            Car Management System • Admin Panel
          </p>
        </form>
      </div>
    </>
  );
}